import type { Components, Theme } from "@mui/material";
import { DefaultSelectMenuElevation } from "./covestro-constants";

export const covestroMuiSelect: Components<Theme>["MuiSelect"] = {
  defaultProps: {
    MenuProps: {
      PaperProps: {
        elevation: DefaultSelectMenuElevation,
      },
    },
  },
};
